module.exports = __webpack_public_path__ + "img/20250813SelmaFynn-36.cc66cc10.jpg";